var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerConsume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76792 11.5659H10.3429V17.5659C10.3429 18.4492 11.4429 18.8659 12.0263 18.1992L18.3346 11.0326C18.8846 10.4076 18.4429 9.43258 17.6096 9.43258H15.0346V3.43258C15.0346 2.54924 13.9346 2.13258 13.3513 2.79924L7.04292 9.96591C6.50125 10.5909 6.94292 11.5659 7.76792 11.5659Z",
    fill: "#00A79D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 4.45898H1.25C0.908333 4.45898 0.625 4.17565 0.625 3.83398C0.625 3.49232 0.908333 3.20898 1.25 3.20898H7.08333C7.425 3.20898 7.70833 3.49232 7.70833 3.83398C7.70833 4.17565 7.425 4.45898 7.08333 4.45898Z",
    fill: "#00A79D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 17.791H1.25C0.908333 17.791 0.625 17.5077 0.625 17.166C0.625 16.8243 0.908333 16.541 1.25 16.541H6.25C6.59167 16.541 6.875 16.8243 6.875 17.166C6.875 17.5077 6.59167 17.791 6.25 17.791Z",
    fill: "#00A79D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 11.125H1.25C0.908333 11.125 0.625 10.8417 0.625 10.5C0.625 10.1583 0.908333 9.875 1.25 9.875H3.75C4.09167 9.875 4.375 10.1583 4.375 10.5C4.375 10.8417 4.09167 11.125 3.75 11.125Z",
    fill: "#00A79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerConsume);
export default __webpack_public_path__ + "static/media/power-consume.262e989fcd902af8420a78e4bb3ff661.svg";
export { ForwardRef as ReactComponent };